// Talks to Media Studio's idea pipeline: start (Click 1), approve (Click 2), status.
// The work itself runs on the server, so none of this needs the browser to stay open.
import { MEDIA_STUDIO_API_KEY } from '../constants';

const BASE = 'https://strategic-honesty-media-studio-production.up.railway.app/api/pipeline';

export function createPipelineApi({ fetchImpl = (...a) => fetch(...a), base = BASE, key = MEDIA_STUDIO_API_KEY } = {}) {
  const call = async (path, options = {}) => {
    try {
      const res = await fetchImpl(`${base}${path}`, {
        ...options,
        headers: { 'Content-Type': 'application/json', ...(key ? { 'x-api-key': key } : {}) },
      });
      let body = null;
      try { body = await res.json(); } catch { /* not JSON */ }
      return { ok: res.ok, status: res.status, body };
    } catch (err) {
      return { ok: false, status: 'network', body: null, error: err.message };
    }
  };
  const id = (ideaId) => encodeURIComponent(ideaId);
  return {
    start: (ideaId) => call('/start', { method: 'POST', body: JSON.stringify({ ideaId }) }),
    approve: (ideaId, rejected = []) => call(`/${id(ideaId)}/approve`, { method: 'POST', body: JSON.stringify({ rejected }) }),
    status: (ideaId) => call(`/${id(ideaId)}`),
    list: () => call(''),
  };
}

export const pipelineApi = createPipelineApi();

// Plain-English message for a failed call (never a bare status code).
export function describeError(res) {
  if (!res) return 'Something went wrong.';
  if (res.status === 'network') return "Couldn't reach the server. Check your connection and try again.";
  if (res.status === 401 || res.status === 403) return 'The server rejected this app’s API key (HTTP ' + res.status + '). The key in this build no longer matches the backend.';
  if (res.status === 503) return 'The workflow engine is not running on the server right now. Try again in a minute.';
  if (res.status === 404) return (res.body && res.body.error) || 'Not found.';
  if (res.status === 409) return (res.body && res.body.error) || 'That cannot be done in the current state.';
  return (res.body && res.body.error) || `The server returned an error (HTTP ${res.status}).`;
}

// How long to wait before asking again. Stops when nothing is changing on its own:
// "ready" is waiting for the owner, "completed" and "failed" are finished.
export function nextPollDelay(status) {
  if (status === 'running') return 6000;
  if (status === 'scheduling') return 3000;
  return null;
}
